import { render } from "./TarifaAseg.vue?vue&type=template&id=f7de42ea"
import script from "./TarifaAseg.vue?vue&type=script&lang=js"
export * from "./TarifaAseg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__